import { render, staticRenderFns } from "./startUp.vue?vue&type=template&id=ce1c92bc"
import script from "./startUp.vue?vue&type=script&lang=js"
export * from "./startUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports